var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tabs-container", class: _vm.customClass },
    [
      _c("ul", { staticClass: "nav nav-tabs", class: _vm.navTabsClass }, [
        _c(
          "div",
          { staticClass: "container d-flex center-list p-0" },
          _vm._l(_vm.tabs, function(tab, index) {
            return _c(
              "li",
              {
                key: index,
                class:
                  "nav-item " +
                  (_vm.navItemClass ? " " + _vm.navItemClass : "") +
                  (tab.is_active ? " active" : "")
              },
              [
                _c("a", {
                  staticClass: "nav-link",
                  class: { active: tab.is_active },
                  attrs: { href: tab.href },
                  domProps: { innerHTML: _vm._s(tab.name) },
                  on: {
                    click: function($event) {
                      return _vm.selectTab(tab)
                    }
                  }
                })
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _vm._t("sublevel"),
      _vm._v(" "),
      _c("div", { staticClass: "tab-content", class: _vm.tabContentClass }, [
        _c("div", { attrs: { role: "tabpanel" } }, [_vm._t("tabs-content")], 2)
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }